import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicenseeReturnDetailsAsync,
  ILicenseeReturnDetails,
} from "../../api/ILicenseeReturns";
import { RootState } from "../store";

export interface LicenseeReturnState {
  fetchStatus: string;
  licenseeReturn?: ILicenseeReturnDetails;
}

const initialState: LicenseeReturnState = {
  fetchStatus: "Loading...",
  licenseeReturn: undefined,
};

export const loadLicenseeReturnAsync = createAsyncThunk(
  "licenseeReturn/load",
  async (licenseeReturnId: string) => {
    const response = await GetLicenseeReturnDetailsAsync(licenseeReturnId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const licenseeReturnSlice = createSlice({
  name: "licenseeReturn",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicenseeReturnAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicenseeReturnAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licenseeReturn = action.payload;
      });
  },
});

export const selectLicenseeReturn = (state: RootState) => state.licenseeReturn;

export default licenseeReturnSlice.reducer;
